import { Container, Row, Col, Button, Form, Alert, Spinner } from 'react-bootstrap'
import { StepHeader } from '../StepHeader/StepHeader'
import { StepperComponent } from '../../Components/StepperComponent/StepperComponent'
import { useLocation, useNavigate } from 'react-router-dom'
import { useLocalStorage } from '../../Hooks/useLocalStorage'
import { useEffect, useState } from 'react'
import config from '../../config'

export const Step4 = () => {
  const navigate = useNavigate()
  const { state } = useLocation()
  const [loading, setLoading] = useState(false)
  const [projectsFolderId, setProjectsFolderId] = useLocalStorage('projectsFolderId', '')
  const [projectsFieldsString, setProjectsFieldsString] = useState(
    'ID,name,description,status,actualStartDate,actualCompletionDate',
  )
  const [projectsFilterString, setProjectsFIlterString] = useState('')
  const [issueFilterString, setIssueFilterString] = useState('')
  const [taskFilterString, setTaskFilterString] = useState('')
  const [documentsFilterString, setDocumentsFilterString] = useState('')
  const [projectsSortString, setProjectsSortString] = useState('')
  const [selectedTasks, setSelectedTasks] = useState(false)
  const [tasksQueryString, setTasksQueryString] = useState(
    'ID, name, status, description, taskNumber, actualStartDate, actualCompletionDate',
  )
  const [tasksFolderId, setTasksFolderId] = useLocalStorage('tasksFolderId', '')
  const [selectedIssues, setSelectedIssues] = useState(false)
  const [issuesFolderId, setIssuesFolderId] = useLocalStorage('issuesFolderId', '')
  const [issuesQueryString, setIssuesQueryString] = useState(
    'ID, name, status, description, actualStartDate, actualCompletionDate',
  )
  const [selectedDocuments, setSelectedDocuments] = useState(false)
  const [documentsFolderId, setDocumentsFolderId] = useLocalStorage('documentsFolderId', '')
  const [documentsQueryString, setDocumentsQueryString] = useState(
    'ID, name, projectID, downloadURL',
  )
  const [selectedUpdates, setSelectedUpdates] = useState(false)
  const [migrationProfile, setMigrationProfile] = useState()
  const [errorMessage, setErrorMessage] = useState()
  const selectedWorkspace = useLocalStorage('selectedWorkspace')
  const [conditionsMet, setConditionsMet] = useState(true)
  const [conditionsErrorMessage, setConditionsErrorMessage] = useState('')
  const [startPinging, setStartPinging] = useState(false)
  const [projectEssentialsMigration, setProjectEssentialsMigration] = useState(true)

  const fetchWithTimeout = async (url, options = {}, timeout = 60000) => {
    const controller = new AbortController()
    const id = setTimeout(() => controller.abort(), timeout) // Set timeout (e.g., 60s)

    try {
      const response = await fetch(url, { ...options, signal: controller.signal })
      clearTimeout(id)
      return response
    } catch (error) {
      clearTimeout(id)
      if (error.name === 'AbortError') {
        throw new Error('Request timed out')
      }
      throw error
    }
  }

  useEffect(() => {
    if (migrationProfile) {
      navigate('/step5', {
        state: {
          migrationProfile,
          projectsFieldsString,
          projectsFolderId,
          tasksQueryString,
          tasksFolderId,
          issuesQueryString,
          issuesFolderId,
          documentsQueryString,
          selectedTasks,
          selectedIssues,
          selectedDocuments,
          documentsFolderId,
          selectedUpdates,
          projectEssentialsMigration,
        },
      })
    }
  }, [
    migrationProfile,
    projectsFieldsString,
    projectsFolderId,
    tasksQueryString,
    tasksFolderId,
    issuesQueryString,
    issuesFolderId,
    documentsQueryString,
    selectedTasks,
    selectedIssues,
    selectedDocuments,
    documentsFolderId,
    selectedUpdates,
    projectEssentialsMigration,
    navigate,
  ])

  const checkFolderIds = () => {
    let checkboxes = [selectedTasks, selectedIssues, selectedDocuments]
    let inputValues = [tasksFolderId, issuesFolderId, documentsFolderId]
    if (projectsFolderId === '') {
      setConditionsMet(false)
      setConditionsErrorMessage('Please provide Folder ID for the Projects Field')
      return false
    }
    for (let i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i] === true && inputValues[i] === '') {
        setConditionsMet(false)
        if (i === 0) setConditionsErrorMessage('Please provide Folder ID for the Tasks Field !')
        else if (i === 1)
          setConditionsErrorMessage('Please provide Folder ID for the Issues Field !')
        else if (i === 2)
          setConditionsErrorMessage('Please provide Folder ID for the Documents Field !')
        return false
      }
    }
    setConditionsMet(true)
    return true
  }

  const pingBackendForStatus = async () => {
    const resp = await fetch(`${config.BACKEND_URL}/migrate/review-status`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'ngrok-skip-browser-warning': '69420',
      },
      credentials: 'include',
    })

    return resp
  }

  useEffect(() => {
    if (!startPinging) return
    let intervalId

    const fetchStatus = async () => {
      try {
        const respPing = await pingBackendForStatus()
        if (respPing.status === 200) {
          const responseData = await respPing.json()
          setMigrationProfile(responseData)
          setLoading(false)
          setStartPinging(false)
          clearInterval(intervalId) // Stop polling once data is received
        }
      } catch (error) {
        console.error('Error fetching status:', error)
      }
    }

    // Start polling every 30 seconds
    intervalId = setInterval(fetchStatus, 30000)

    fetchStatus()

    return () => clearInterval(intervalId)
  }, [startPinging])

  const handleReview = async (projectFolderID) => {
    setLoading(true)
    setErrorMessage(undefined)
    const reponse = await fetchWithTimeout(
      `${config.BACKEND_URL}/migrate`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'ngrok-skip-browser-warning': '69420',
        },
        credentials: 'include',
        // U HEADERU IDE ACCESS TOKEN OD USERA, TRENUTNO HARDCODANO NA BACKEDNU
        body: JSON.stringify({
          isCustomMigration: !projectEssentialsMigration,
          workspaceId: selectedWorkspace[0].id,
          folderId: projectsFolderId || projectFolderID,
          fields: projectsFieldsString,
          filter: projectsFilterString,
          taskFilter: taskFilterString,
          issueFilter: issueFilterString,
          documentsFilter: documentsFilterString,
          sort: projectsSortString,
          tasks: {
            selected: selectedTasks,
            folderId: tasksFolderId,
            queryString: tasksQueryString,
          },
          issues: {
            selected: selectedIssues,
            folderId: issuesFolderId,
            queryString: issuesQueryString,
          },
          documents: {
            selected: selectedDocuments,
            folderId: documentsFolderId,
            queryString: documentsQueryString,
          },
        }),
      },
      600000,
    )

    if (!reponse.ok) {
      setLoading(false)
      console.error('Something happend', reponse.status)
      const errorData = await reponse.text()
      if (reponse.status === 500) {
        setErrorMessage(
          'An issue has occured, please verify input data (folder id or query parameter )',
        )
      } else {
        setErrorMessage(errorData)
      }
    } else {
      setStartPinging(true)
    }
  }

  const handleProjectEssentialsReview = async () => {
    const workspaceFolders = await fetch(`${config.BACKEND_URL}/monday/workspaceFolders`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'ngrok-skip-browser-warning': '69420',
      },
      credentials: 'include',
      // U HEADERU IDE ACCESS TOKEN OD USERA, TRENUTNO HARDCODANO NA BACKEDNU
      body: JSON.stringify({
        workspaceId: selectedWorkspace[0].id,
      }),
    })
    const foldersData = await workspaceFolders.json()
    const folders = foldersData?.folders
    const projectManagementFolder = folders.find((folder) => folder.name === 'Project Management')
    const taskManagementFolder = folders.find((folder) => folder.name === 'Task Management')

    if (!projectManagementFolder) {
      setErrorMessage('Project Management folder is missing')
      return
    }
    if (!taskManagementFolder) {
      setErrorMessage('Task Management folder is missing')
      return
    }

    // Set folder IDs BEFORE calling handleReview
    setProjectsFolderId(projectManagementFolder?.id)
    setTasksFolderId(taskManagementFolder?.id)
    setDocumentsFolderId(projectManagementFolder?.id)

    // Wait for state to update before calling handleReview
    // Use setTimeout to ensure state has been updated
    setTimeout(async () => {
      await handleReview(projectManagementFolder?.id)
    }, 100)
  }

  if (loading) {
    return (
      <Container>
        <Row>
          <StepHeader />
        </Row>
        <Row>
          <Col>
            <StepperComponent currentStep={4} />
          </Col>
        </Row>
        <Row className="d-flex align-items-center justify-content-center">
          <Spinner animation="grow" variant="dark" />
          <div style={{ textAlign: 'center', marginTop: 15 }}>This can take up to 10 minutes.</div>
        </Row>
      </Container>
    )
  }

  return (
    <Container>
      <Row>
        <StepHeader />
      </Row>
      <Row>
        <Col>
          <StepperComponent currentStep={4} />
        </Col>
      </Row>
      <Row className={'d-flex mb-3 justify-content-center'}>
        <Col md={2}></Col>
        <Col md={8}>
          <Form.Check
            onChange={(e) => setProjectEssentialsMigration(!e.target.checked)}
            type="switch"
            label="Custom migration"
          />
        </Col>
      </Row>
      {/* {PROJECTS ROW AREA} */}
      <Row className={'d-flex mb-3 justify-content-center'}>
        <Col md={2} className={'align-self-flex-start mt-2'}>
          <div>{'Projects'}</div>
        </Col>
        <Col md={8}>
          <Form>
            <Form.Control
              className={'mb-3'}
              placeholder={
                projectEssentialsMigration ? 'folder: Project Management' : 'Folder ID (required)'
              }
              value={projectEssentialsMigration ? '' : projectsFolderId}
              disabled={projectEssentialsMigration}
              onChange={(e) => {
                setProjectsFolderId(e.target.value)
              }}
            ></Form.Control>
            <Form.Control
              className={'mb-3'}
              placeholder={
                'name,ID,status,description,startDate,completionDate,portfolio:name,program:name'
              }
              value={projectsFieldsString}
              onChange={(e) => {
                setProjectsFieldsString(e.target.value)
              }}
            ></Form.Control>
            <Form.Control
              className={'mb-3'}
              placeholder={'Filter'}
              value={projectsFilterString}
              onChange={(e) => {
                setProjectsFIlterString(e.target.value)
              }}
            ></Form.Control>
            <Form.Control
              className={'mb-3'}
              placeholder={'Sort'}
              value={projectsSortString}
              onChange={(e) => {
                setProjectsSortString(e.target.value)
              }}
            ></Form.Control>
          </Form>
        </Col>
      </Row>
      {/* {TASKS ROW AREA} */}
      <Row className={'d-flex mb-3 justify-content-center'}>
        <Col md={2} className={'align-self-start'}>
          <Form>
            <Form.Check
              inline
              label={'Tasks'}
              checked={selectedTasks}
              onChange={(e) => {
                setSelectedTasks(e.target.checked)
              }}
            ></Form.Check>
          </Form>
        </Col>
        <Col md={8}>
          <Form>
            <Form.Control
              className={'mb-3'}
              placeholder={
                projectEssentialsMigration ? 'folder: Task Management' : 'Folder ID (required)'
              }
              disabled={projectEssentialsMigration}
              value={projectEssentialsMigration ? '' : tasksFolderId}
              onChange={(e) => {
                setTasksFolderId(e.target.value)
              }}
            ></Form.Control>
            <Form.Control
              className={'mb-3'}
              placeholder={'name,ID,status,description,startDate,completionDate'}
              value={tasksQueryString}
              onChange={(e) => {
                setTasksQueryString(e.target.value)
              }}
            ></Form.Control>
            <Form.Control
              className={'mb-3'}
              placeholder={'Filter'}
              value={taskFilterString}
              onChange={(e) => {
                setTaskFilterString(e.target.value)
              }}
            ></Form.Control>
          </Form>
        </Col>
      </Row>
      {/* {ISSUES ROW AREA} */}
      <Row className={'d-flex mb-3 justify-content-center'}>
        <Col md={2} className={'align-self-start'}>
          <Form>
            <Form.Check
              inline
              label={'Issues'}
              checked={selectedIssues}
              onChange={(e) => {
                setSelectedIssues(e.target.checked)
              }}
            ></Form.Check>
          </Form>
        </Col>
        <Col md={8}>
          <Form>
            <Form.Control
              className={'mb-3'}
              placeholder={
                projectEssentialsMigration
                  ? 'folder: Task Management and Project Management subitems'
                  : 'Folder ID (required)'
              }
              disabled={projectEssentialsMigration}
              value={projectEssentialsMigration ? '' : issuesFolderId}
              onChange={(e) => {
                setIssuesFolderId(e.target.value)
              }}
            ></Form.Control>
            <Form.Control
              className={'mb-3'}
              placeholder={'name,ID,status,description,startDate,completionDate'}
              value={issuesQueryString}
              onChange={(e) => {
                setIssuesQueryString(e.target.value)
              }}
            ></Form.Control>
            <Form.Control
              className={'mb-3'}
              placeholder={'Filter'}
              value={issueFilterString}
              onChange={(e) => {
                setIssueFilterString(e.target.value)
              }}
            ></Form.Control>
          </Form>
        </Col>
      </Row>
      {/* {DOCUMENTS ROW AREA} */}
      <Row className={'d-flex mb-3 justify-content-center'}>
        <Col md={2} className={'align-self-start'}>
          <Form>
            <Form.Check
              inline
              label={'Documents'}
              checked={selectedDocuments}
              onChange={(e) => {
                setSelectedDocuments(e.target.checked)
              }}
            ></Form.Check>
          </Form>
        </Col>
        <Col md={8}>
          <Form>
            <Form.Control
              className={'mb-3'}
              placeholder={
                projectEssentialsMigration ? 'folder: Project Management' : 'Folder ID (required)'
              }
              disabled={projectEssentialsMigration}
              value={projectEssentialsMigration ? '' : documentsFolderId}
              onChange={(e) => {
                setDocumentsFolderId(e.target.value)
              }}
            ></Form.Control>
            <Form.Control
              className={'mb-3'}
              placeholder={'name,ID'}
              value={documentsQueryString}
              onChange={(e) => {
                setDocumentsQueryString(e.target.value)
              }}
            ></Form.Control>
            <Form.Control
              className={'mb-3'}
              placeholder={'Filter'}
              value={documentsFilterString}
              onChange={(e) => {
                setDocumentsFilterString(e.target.value)
              }}
            ></Form.Control>
          </Form>
        </Col>
      </Row>
      {/* {UPDATES ROW AREA} */}
      <Row className={'d-flex mb-3 justify-content-center'}>
        <Col md={10} className={'align-self-start'}>
          <Form>
            <Form.Check
              inline
              label={'Updates'}
              checked={selectedUpdates}
              onChange={(e) => {
                setSelectedUpdates(e.target.checked)
              }}
            ></Form.Check>
          </Form>
        </Col>
      </Row>
      {errorMessage && (
        <Row className={'mt-5 d-flex mb-3 justify-content-center'}>
          <Col md={10}>
            <Alert variant={'danger'}>{errorMessage}</Alert>
          </Col>
        </Row>
      )}
      {!conditionsMet && (
        <Row className={'mt-5 d-flex mb-3 justify-content-center'}>
          <Col md={10}>
            <Alert variant={'danger'}>{conditionsErrorMessage}</Alert>
          </Col>
        </Row>
      )}
      <Row className={'mt-5'}>
        <Col xs={11} className={'d-flex justify-content-end'}>
          <Button className={'me-5'} onClick={() => navigate('/step3')}>
            Back
          </Button>
          <Button
            onClick={async () => {
              if (projectEssentialsMigration) {
                handleProjectEssentialsReview()
              } else {
                const conditions = checkFolderIds()
                if (conditions) {
                  handleReview()
                }
              }
            }}
          >
            Review
          </Button>
        </Col>
      </Row>

      <hr className="mt-5 mb-3" />
      {/* {INSTRUCTIONS AREA} */}
      <Row>
        <Col md={10} className={''}>
          <div className={'mb-5 mt-3'}>INSTRUCTIONS</div>
          <div>
            Select the types of objects to be included in the migration, then click the Run
            Migration button.
          </div>
          <div className={'mb-3 mt-5'}>Fields</div>
          <div>
            {
              'Choose the fields to migrated by modifying the comma-delisted list of field names located in the text field to the right of each object type. The field names of parent objects can also be included by using Workfront’s field selection syntax (e.g. portfolio:name). All custom fields are automatically migrated.'
            }
          </div>
          <div className={'mb-3 mt-5'}>
            Map the following field types in Workfront to field types in Monday:
          </div>
          <ul>
            <li>{'Built-in Status field > Status'}</li>
            <li>{'Text > Text'}</li>
            <li>{'Text Area > Text'}</li>
            <li>{'Select > Dropdown'}</li>
            <li>{'Radio > Dropdown'}</li>
            <li>{'Checkbox > Dropdown'}</li>
            <li>{'Number > Number'}</li>
            <li>{'Date > Date'}</li>
            <li>{'Date/Time > Date'}</li>
          </ul>
          <div className={'mb-3 mt-5'}>Filters</div>
          <div>
            {
              'By default, all projects will be migrated. Filter the list of any object by entering a valid Workfront query into the “Filter” field. The syntax of the filter text should conform to the Workfront API search query syntax. For example, to exclude dead projects enter the following filter: statusEquatesWith_Mod=notin&statusEquatesWith=DED.'
            }
          </div>
          <div className={'mt-4'}>
            {
              ' Only tasks, issues, and documents within the selected projects will also be migrated. Further filter the list of tasks, issues and documents using the corresponding “Filter” field. For example, to exclude child tasks, enter following filter: parentID_Mod=isnull.'
            }
          </div>
          <div className={'mb-3 mt-5'}>Sorting Projects</div>
          <div>
            {
              ' Sorting Projects By default, projects are sorted by entryDate in descending order. You can override this by entering the desired sort order into the Sort field using Workfront API sort syntax. For example, the following will reverse the sort so that projects are listed in ascending order: entryDate_Sort=asc '
            }
          </div>
          <div className={'mb-3 mt-5'}>Object Structure in Monday</div>
          <div>
            {
              'Object Structure in Monday The migration will create a single top-level folder named “WF Migration”. This folder contains a Board named “All Projects” and the following optional sub-folders: Tasks, Issues, and Documents.'
            }
          </div>
          <img
            className="d-inline-block mt-5 mb-3"
            alt="Marketo logo"
            src="/s4img1.png"
            style={{
              height: '14rem',
            }}
          />
          <div className={'mb-3 mt-5'}>All Projects Board</div>
          <div>
            {
              'All Projects Board The WF Project folder contains a single Board called “All Projects”. This board contains every migrated project. This flat structure allows users to manually organize migrated projects into a final structure.'
            }
          </div>
          <div className={'mb-3 mt-5'}>Tasks Folder</div>
          <div>
            {
              'Tasks Folder The Tasks folder contains a Board for each migrated project. Each board lists contains a list of all migrated tasks for the given project.'
            }
          </div>
          <div className={'mt-5'}>
            {
              'Monday doesn’t support nested sub-tasks like Workfront. Because of this, tasks will be migrated to Monday as a flat list, but with a “Level” field. The Level value indicates the depth of a task.'
            }
          </div>
          <div className={'mt-5'}>
            {
              'The Workfront API supports a nested field depth up to 4 levels. Because of this, the migration is limited to a depth of 4 tasks. Child tasks deeper than 4 levels will be excluded from the migration. Including nested objects in the Fields input for Tasks (above) will limit this further.'
            }
          </div>
          <div className={'mt-5'}>
            {
              'Tech note: The migration gets all tasks for a given project using the following API syntax: /attask/api/v15.0/PROJ/<ID>?fields=tasks:<task_fields>,tasks:children:<task_fields>,tasks:children:children:<task_fields>.'
            }
          </div>
          <img
            className="d-inline-block mt-5 mb-3"
            alt="Marketo logo"
            src="/s4img2.png"
            style={{
              height: '14rem',
            }}
          />
          <div className={'mb-3 mt-5'}>Re-Running the Migration</div>
          <div>{'We recommend running each migration within a dedicated Workspace.'}</div>
          <div className={'mt-4'}>
            {
              'Each migration runs independently of previous migrations. As such, the migration creates new top-level folders with the same names every time it runs.'
            }
          </div>
          <div className={'mb-3 mt-5'}>Limitations:</div>
          <ul>
            <li>{'File sizes are limited 500 MB.'}</li>
            <li>
              {
                'Monday boards are limited 10,000 items. Because of this, it may be necessary apply a filter the projects being run and split the migration into multiple runs. '
              }
            </li>
            <li>
              {
                'No links are created between boards. For example, the migration doesn’t link a project item in the “All Projects” board to the corresponding board for that project’s tasks.'
              }
            </li>
            <li>
              {
                'Monday doesn’t support new lines in text fields. Convert new lines in Workfront to spaces in Monday. '
              }
            </li>
            <li>{'Monday text fields are limited to 2,000 characters.'}</li>
            <li>{'Workfront comments aren’t migrated.'}</li>
            <li>{'Child tasks are limited to 4 levels (see above)'}</li>
          </ul>
        </Col>
      </Row>
    </Container>
  )
}
